import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvConfigServices extends CoreJsonAPIService {
  static async getConfig() {
    return await super.get<{ homepageURL: string }>(EDjangoAppsEndpoints.CONFIG, '');
  }
}
